import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import SettingPageLayout from '../../common/PageLayout/Setting';
import { changeToSettingMode } from '../../../js/actions/appModeActionCreators';

const SettingsPage = React.createClass({
    propTypes: {
        alignMode: PropTypes.func.isRequired,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    },
    componentDidMount: function () {
        this.props.alignMode();
    },
    render: function () {
        return (
            <SettingPageLayout>
                {this.props.children}
            </SettingPageLayout>
        );
    }
});

const mapDispatchToProps = (dispatch) => {
    return {
        alignMode: () => {
            dispatch(changeToSettingMode());
        }
    };
};

export default connect(null, mapDispatchToProps)(SettingsPage);



// WEBPACK FOOTER //
// ./src/components/settings/SettingsPage/index.jsx